'use client';
import style from './slider.module.scss';
import SwiperCarousel from '../../common/swiper/SwiperCarousel';
import SliderGroup from './slider-group/SliderGroup';
// import { useOpenWindows } from '@/contexts/useContextFunctions';
import SlideItem from './slide-item/SlideItem';
import { useEffect, useState } from 'react';
import Container from '../../common/general/container/Container';
import SliderDto from '@/projectRoot/api-client/interfaces/models/content/sitemap/blocks/Slider.dto';
import { useGlobals } from '@/projectRoot/src/contexts/GlobalsContext';

interface Props {
    slider: SliderDto;
    component_key?: number;
    fetchPriority?: boolean;
}

function chunkArray(array: any[], size: number){
    const resultingArray: any[] = [];
    for(let i = 0; i < array.length; i += size){
        resultingArray.push(array.slice(i, i + size));
    }
    return resultingArray;
}

const Slider = ({slider, component_key = 10, fetchPriority = false}: Props) => {
    const {isMobileView} = useGlobals();
    
  return (
    <section className={style.leadSection}>
        <SwiperCarousel
            sliderClassName={style.slider}
            // nav
            // navIds={{prev: component_key, next: component_key + 1}}
            // prevBtnClassName={[style.prev]}
            // nextBtnClassName={[style.next]}
            dots={true}
            dotsClassName='dots'
            singleDotClassName='dot'
            activeDotClassName='active'
            slidesPerView={1}
            freeMode
        >
        { 
            slider.items.sort((a, b) => (a.order || 0) - (b.order || 0)).map((slide) => 
                <SlideItem 
                    key={slide.uid} 
                    slide={slide} 
                    classes={[`${style.slideItem}`]} 
                    fetchPriority={fetchPriority} 
                />
            )
        }
        </SwiperCarousel>
    </section>
  )
};

export default Slider;
